import { createFileRoute } from "@tanstack/react-router";
import {
  Stack,
  Title,
  Text,
  Paper,
  Timeline,
  Button,
  Affix,
  Flex,
  Box,
} from "@mantine/core";
import BankIDLogo from "../../assets/bank-id-logo.svg";
import { useState } from "react";
import POASteps from "../../components/PoaSteps";
import { z } from "zod";

const signupParamsSchema = z.object({
  agent_id: z.union([z.string(), z.null(), z.undefined()]),
});

export const Route = createFileRoute("/signup/")({
  component: SignupPage,
  validateSearch: signupParamsSchema,
});

function SignupPage() {
  const [isStartingPOA, setIsStartingPOA] = useState(false);
  const [userCancelled, setUserCancelled] = useState(false);

  return (
    <Box>
      {isStartingPOA && !userCancelled ? (
        <POASteps setUserCancelled={setUserCancelled} />
      ) : (
        <Stack p={"xl"}>
          <Title ff={"var(--wallet-font-family-subjecttivity)"}>
            Välkommen!
          </Title>
          <Text>
            Du är på god väg att förbättra din pension. Innan vi kan rådge dig
            så måste vi få lite information om dig och ditt sparande.{" "}
          </Text>
          <Paper p={30} radius={"24px"} mb={"2rem"}>
            <Title
              order={3}
              mb={"xl"}
              ff={"var(--wallet-font-family-subjecttivity)"}
            >
              Såhär kommer det att gå till
            </Title>
            <Timeline
              active={4}
              bulletSize={28}
              color={"var(--wallet-color-sambla-red-shade-600)"}
            >
              <Timeline.Item bullet={1}>
                <Title order={5}>Legitimera dig med BankID</Title>
                <Text c="dimmed" size="sm">
                  Genom att verifiera din identitet kan vi se till att din
                  information är korrekt och att den bara delas med rätt person.
                  På så sätt skyddar vi både dig och din personliga data.
                </Text>
              </Timeline.Item>
              <Timeline.Item bullet={2}>
                <Title order={5}>Fyll i dina kontaktuppgifter</Title>
                <Text c="dimmed" size="sm">
                  Kontaktuppgifterna behövs för att kunna hämta en fullmakt och
                  för att kunna nå dig när det är dags för rådgivning.
                </Text>
              </Timeline.Item>
              <Timeline.Item bullet={3}>
                <Title order={5}>Signera en fullmakt</Title>
                <Text c="dimmed" size="sm">
                  Fullmakten ger oss tillgång till information om din pension
                  och lägger grunden till din rådgivning.
                </Text>
              </Timeline.Item>
              <Timeline.Item bullet={4}>
                <Title order={5}>Boka ett rådgivningsmöte</Title>
                <Text c="dimmed" size="sm">
                  Du bokar in en tid som passar dig. Fram till mötet kikar vi på
                  din pension och förbereder personliga råd om hur du kan
                  förbättra ditt sparande.
                </Text>
              </Timeline.Item>
            </Timeline>
          </Paper>
          <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
            <Flex justify={"center"}>
              <Button
                onClick={() => {
                  setUserCancelled(false);
                  setIsStartingPOA(true);
                }}
              >
                Legitimera
                <Box ml={"sm"}>
                  <BankIDLogo />
                </Box>
              </Button>
            </Flex>
          </Affix>
        </Stack>
      )}
    </Box>
  );
}
